import { z } from 'zod'
import { PRODUCT_TYPES } from 'services/ProductTypeState'
import { StoredPhotoBookSchema } from 'services/PhotoBook/photoBookStorage.schema'
import { RemotePhotoSchema } from 'components/PhotoBank/PhotoBank.schemas'
import { TileDataSchema } from 'stores/tilesStore/tiles/tileSchemas'

export const AbandonedCartTilesPayloadSchema = z.object({
  tiles: z.array(TileDataSchema),
  photos: z.array(RemotePhotoSchema),
  bulkOptions: z.object({
    tileSize: z.string(),
    materialType: z.string(),
  }),
})

export const AbandonedCartBookPayloadSchema = z.object({
  book: StoredPhotoBookSchema,
  photos: z.array(RemotePhotoSchema),
})

const AbandonedCartItemBaseSchema = z.object({ title: z.string() })

export const AbandonedCartItemSchema = z.discriminatedUnion('productType', [
  AbandonedCartItemBaseSchema.extend({
    productType: z.literal(PRODUCT_TYPES.CLASSIC),
    restorePayload: AbandonedCartTilesPayloadSchema,
  }),
  AbandonedCartItemBaseSchema.extend({
    productType: z.literal(PRODUCT_TYPES.PHOTO_BOOK),
    restorePayload: AbandonedCartBookPayloadSchema,
  }),
])

export type AbandonedCartItem = z.infer<typeof AbandonedCartItemSchema>
